import axios from 'axios';

export const htmlId: string = 'favorite-products';
export const categoryMessageError: string = 'ERROR_OCCURRED_WHILE_RETRIEVING_THE_CATEGORY';
export const addFavoriteProductMessageError: string = 'ERROR_OCCURRED_WHILE_ADDING_FAVORITE_PRODUCT';
export const getFavoriteProductMessageError: string = 'ERROR_OCCURRED_WHILE_GETTING_FAVORITE_PRODUCTS';
export const heightImg: number = 80;
export const widthImg: number = 80;
const prefix: string = 'products/';

export const updateFavoriteProduct = (
    categoryUuid: string,
    parentProductUuid: string,
    variantProductUuid: string,
    isActive: boolean
): any => {
    return axios.post(
        `${prefix}UpdateFavoriteProduct/${categoryUuid}/${parentProductUuid}/${variantProductUuid}/${isActive}`
    );
};

export const getFavoriteProducts = (categoryUuid: string, languageCode: string | null): any => {
    return axios.get(`${prefix}GetFavoriteProducts/${categoryUuid}/${languageCode}`);
};
